export let auxShowErrorScreen = false;

export const auxHandleChangeErrorScreen = (value) => auxShowErrorScreen = value;
